import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const BUTTONBLOCK_LEGACY_FIELD_ORDER = [
  "type",
  "color",
  "label",
  "url",
  "button-size-y"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  buttonBlockDescriptor: _generatedButtonBlockDescriptor,
  buttonBlockBlocDefinition,
  buttonBlockDashboardLayout,
  buttonBlockConfig,
  buttonBlockResolveConfig,
  buttonBlockProperties,
} = doodBlockConfig(
  {
    name: "Button",
    componentType: 'ButtonBlockComponent',
    category: 'content',
    description: "Button.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    type: propertyValue({
      type: 'select',
      value: "primary",
      options: {
        label: "pages.blocks.button.type.label",
        multiple: false,
        choices: [
          {
            value: "primary",
            label: "pages.blocks.button.type.options.primary",
          },
          {
            value: "light",
            label: "pages.blocks.button.type.options.light",
          },
          {
            value: "outlined",
            label: "pages.blocks.button.type.options.outlined",
          },
        ],
      },
    }),
    color: propertyValue({
      type: 'select',
      value: "primary",
      options: {
        label: "pages.blocks.button.color.label",
        multiple: false,
        choices: [
          {
            value: "primary",
            label: "pages.blocks.button.color.options.primary",
          },
          {
            value: "neutral",
            label: "pages.blocks.button.color.options.neutral",
          },
          {
            value: "success",
            label: "pages.blocks.button.color.options.success",
          },
          {
            value: "info",
            label: "pages.blocks.button.color.options.info",
          },
          {
            value: "highligh",
            label: "pages.blocks.button.color.options.highligh",
          },
        ],
      },
    }),
    label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.button.label.label",
      },
    }),
    url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.button.url.label",
        help: "pages.blocks.button.url.help",
        defaultMode: "page",
        modes: [
          "page",
          "modal",
          "mailto",
          "external",
          "navigationBack",
        ],
      },
    }),
    "button-size-y": propertyValue({
      type: 'select',
      value: "M",
      options: {
        label: "pages.blocks.button.button-size-y.label",
        multiple: false,
        choices: [
          {
            value: "S",
            label: "pages.blocks.button.button-size-y.options.S",
          },
          {
            value: "M",
            label: "pages.blocks.button.button-size-y.options.M",
          },
          {
            value: "L",
            label: "pages.blocks.button.button-size-y.options.L",
          },
        ],
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.button.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.button.fieldset.content.label",
            fields: ["label", "url"],
          },
          {
            legend: "pages.blocks.button.fieldset.appearance.label",
            fields: ["type", "button-size-y", "color"],
          },
        ],
      },
    ],
  })
);

export function buttonBlockDescriptor(): IBlockDescriptor;
export function buttonBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function buttonBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedButtonBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedButtonBlockDescriptor, buttonBlockProperties, fieldOrder);
}

export {
  buttonBlockBlocDefinition,
  buttonBlockDashboardLayout,
  buttonBlockProperties,
  buttonBlockConfig,
  buttonBlockResolveConfig,
};

export type ButtonBlockConfig = typeof buttonBlockConfig;
